import { useFormik } from 'formik';
import { useEffect } from 'react';
import React from 'react';
import { Redirect } from 'react-router';

import { useAppSelector } from '@app/redux/hooks';
import { getMFAPreconditionData } from '@app/redux/mfa/mfa.selectors';
import RoutePaths from '@app/routes/paths';
import useGenerateRoutePath from '@app/routes/paths/useGenerateRoutePath';

import { VerifyPhoneContainer } from '@components/forms/verifyPhone';
import { VerifyPhoneFormValues } from '@components/forms/verifyPhone/interfaces';
import verifyPhoneFormValidationScheme from '@components/forms/verifyPhone/validationScheme';

import MFA_METHODS_ENUM from '@pages/Verification/MFASetupPage/enums/MFA_METHODS.enum';

import { use2FALogin } from '../../use2FALogin';

function SMS2FA({ onDecline }: { onDecline?: () => void }) {
	const { login, sendMFACode, isSendingMFACode } = use2FALogin({ method: MFA_METHODS_ENUM.SMS });
	const mfaPreconditionData = useAppSelector(getMFAPreconditionData);
	const generateRoutePath = useGenerateRoutePath();
	const formik = useFormik<VerifyPhoneFormValues>({
		validationSchema: verifyPhoneFormValidationScheme,
		initialValues: { code: '' },
		onSubmit: login,
	});

	useEffect(() => {
		sendMFACode();
	}, []);

	return mfaPreconditionData ? (
		<VerifyPhoneContainer
			isSendingVerificationPhoneCode={isSendingMFACode}
			handleSendVerificationPhoneCode={sendMFACode}
			onDecline={onDecline}
			isPostLogin={true}
			formik={formik}
		/>
	) : (
		<Redirect to={generateRoutePath(RoutePaths.AUTH.LOGIN)} />
	);
}

export default SMS2FA;
